module.exports = __webpack_public_path__ + "static/media/faces.86b9af3e.png";